module.exports = __webpack_public_path__ + "img/home_web_04.1ae8687e.png";